import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceOrderingService } from 'src/app/services/device-ordering/device-ordering.service';
import { OrderRequestApprovedState } from 'src/app/services/device-ordering/value-objects/order.vo';
import { InitialDataModel } from 'src/app/services/models/initial-data-model.service';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'app-edit-supply-order',
  templateUrl: './edit-supply-order.component.html',
  styleUrls: ['./edit-supply-order.component.scss'],
})
export class EditSupplyOrderComponent implements OnInit {
  supplyForm: UntypedFormGroup;
  showProgressBar = false;
  constructor(
    public dataModel: InitialDataModel,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditSupplyOrderComponent>,
    private deviceService: DeviceOrderingService,
    private snackService: SnackService
  ) {}

  ngOnInit(): void {
    this.supplyForm = this.fb.group({
      comments: [this.data.comments ? this.data.comments : ''],
    });
  }

  reject(): void {
    this.showProgressBar = true;
    const orderRequest = this.data;
    orderRequest.comments = this.supplyForm.get('comments').value;
    orderRequest.approved = OrderRequestApprovedState.FALSE;
    this.deviceService.updateOrderRequest(orderRequest).then(() => {
      this.snackService.genericSnackBar('Order Rejected', ['success-snackbar'], 5000);
      this.close();
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
